module.exports = __webpack_public_path__ + "static/media/ServicesStarRatingIcon.9eff2cf8.svg";